import { render } from "./PermissionCategories.vue?vue&type=template&id=5ace9399"
import script from "./PermissionCategories.vue?vue&type=script&lang=js"
export * from "./PermissionCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__